// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ucro","content":"styles_content__HLa07"};